import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";
import { useParams } from 'react-router-dom';

export default function BlogOther() {
   const sliderRef = useRef(null);
   const { slug } = useParams();
   const [allData, setAllData] = useState([]);

   const convertDate = (dateString) => {
        const date = new Date(dateString);
        const months = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
    };

    const dataFetcher = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/api/blog`);
            setAllData(response.data.data);
        } catch (error) {
            console.error("Data fetch error:", error);
            throw error;
        }
    };

    useEffect(() => {
        dataFetcher();
    }, [])

    if (!allData) {
        return null;
    }

                  
    const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1100,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    cssEase: "ease",
    draggable: false,
    swipe: false,
    responsive: [
        {
        breakpoint: 991,
        settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true,},
        },
        {
        breakpoint: 767,
        settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true,},
        },
        {
        breakpoint: 599,
        settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true,},
        },
    ],
    };

    const CustomArrows = () => (
    <>
      <div className="default-arrowleft default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
          <Icons name="Longarrow_left" />
      </div>
      <div className="default-arrowright default-mobilearrow" onClick={() => sliderRef.current.slickNext()}>
          <Icons name="Longarrow_right" />
      </div>
    </>
    );

  return (
    <>
    <div className="other-blog">
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                  <h4 className="heading center-heading">Discover Other Our Blogs</h4>

                  <div className="position-relative">
                    <Slider {...settings} ref={sliderRef} className="otherblog-slider">

                      {allData && allData.filter(data => data.slug !== slug).slice(0,3).map((card,index)=>( 
                        <div className="bloglist-box" key={index}>
                          <Link to={`/blog/${card.slug}`}>
                            <img src={`${BaseUrl}${card.thumbnail}`} loading="lazy" className="img-responsive" alt="Blog"/>
                            <div className="bloglist-admin">
                                <img src={`${BaseUrl}${card.author_image}`} alt="admin"/>
                                <small>Written by {card.author_name}</small>
                            </div>
                            <p>{card.title}</p>
                            <div className="bloglist-date">
                                <label>{convertDate(card.created_at)}</label>
                                <span><Icons name="Longarrow_right"/></span>
                            </div>
                          </Link>
                        </div>
                      ))}
                      
                    </Slider>
                    <CustomArrows />
                  </div>

                  <div className="text-center">
                    <Link to={"/blog"} className="default-btn colored-btn">View All <Icons name="Longarrow_right"/></Link>
                  </div>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
